
import * as React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  DropdownMenuGroup,
} from './Dropdown'
import { renderMenuItems } from './menu-renderer'

// Menu item types (kept for backward compatibility)
type MenuItemType = {
  type: 'item'
  label: string
  icon?: React.ReactNode
  iconName?: string
  shortcut?: string
  onClick?: () => void
  disabled?: boolean
  variant?: 'default' | 'danger'
}

type MenuSeparatorType = {
  type: 'separator'
}

type MenuLabelType = {
  type: 'label'
  label: string
}

type MenuSubMenuType = {
  type: 'submenu'
  label: string
  items: Array<MenuItemType | MenuSeparatorType | MenuLabelType>
}

export type MenuItem =
  | MenuItemType
  | MenuSeparatorType
  | MenuLabelType
  | MenuSubMenuType

interface DropdownMenuWrapperProps {
  items: MenuItem[]
  children: React.ReactNode
  align?: 'start' | 'center' | 'end'
  side?: 'top' | 'right' | 'bottom' | 'left'
  sideOffset?: number
  contentClassName?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
  modal?: boolean
}

const DropdownMenuWrapper: React.FC<DropdownMenuWrapperProps> = ({
  items,
  children,
  align = 'start',
  side = 'bottom',
  sideOffset = 4,
  contentClassName,
  open,
  onOpenChange,
  modal = false,
}) => {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange} modal={modal}>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        side={side}
        sideOffset={sideOffset}
        className={contentClassName}
      >
        {renderMenuItems(items, {
          DropdownMenuItem,
          DropdownMenuSeparator,
          DropdownMenuLabel,
          DropdownMenuGroup,
          DropdownMenuShortcut,
          DropdownMenuSub,
          DropdownMenuSubTrigger,
          DropdownMenuSubContent,
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { DropdownMenuWrapper }
